// Utilitaires partagés pour la configuration des champs par Type.
// cfg = { catalog: { key: {enabled,label} }, custom: [{id,label,type,enabled,archived,options,min,max,step}], order: ["c:key"|"x:id", ...] }

export const CT = (key) => `c:${key}`;
export const XT = (id) => `x:${id}`;

// Liste ordonnée de tokens. Catalogue : UNIQUEMENT les champs ATTACHÉS au type (présents dans
// cfg.catalog) — les autres champs du catalogue sont ajoutables à la demande, pas affichés par défaut.
export function orderedTokens(cfg, fieldCatalog = []) {
  const catalog = cfg?.catalog || {};
  const custom = (cfg?.custom || []).filter((c) => !c.archived);
  const catalogKeys = new Set(fieldCatalog.map((f) => f.key));
  const attached = Object.keys(catalog).filter((k) => catalogKeys.has(k));
  const all = [...attached.map((k) => CT(k)), ...custom.map((c) => XT(c.id))];
  const allSet = new Set(all);
  const saved = Array.isArray(cfg?.order) ? cfg.order.filter((t) => allSet.has(t)) : [];
  const missing = all.filter((t) => !saved.includes(t));
  return [...saved, ...missing];
}

// Clés catalogue NON encore attachées à un type (pour le picker « Ajouter un champ »).
export function unattachedCatalogFields(cfg, fieldCatalog = []) {
  const catalog = cfg?.catalog || {};
  return fieldCatalog.filter((f) => !(f.key in catalog));
}

// Résout un token en descripteur de champ (ou null si introuvable / archivé).
export function resolveToken(token, cfg, fieldCatalog = []) {
  const catalog = cfg?.catalog || {};
  if (token.startsWith("c:")) {
    const key = token.slice(2);
    const f = fieldCatalog.find((x) => x.key === key);
    if (!f) return null;
    return {
      kind: "catalog",
      key,
      token,
      enabled: catalog[key]?.enabled !== false,
      label: catalog[key]?.label || f.label,
      input: f.input,
      options: f.options,
    };
  }
  const id = token.slice(2);
  const c = (cfg?.custom || []).find((x) => x.id === id);
  if (!c || c.archived) return null;
  return {
    kind: "custom",
    id,
    token,
    enabled: c.enabled !== false,
    label: c.label,
    input: c.type,
    options: c.options,
    min: c.min,
    max: c.max,
    step: c.step,
  };
}

// Champs ACTIFS, dans l'ordre — utilisé par le formulaire et la fiche.
export function orderedActiveFields(cfg, fieldCatalog = []) {
  // Pas de config → tout le catalogue actif (rétrocompat automobile).
  if (!cfg || (!cfg.catalog && !cfg.custom && !cfg.order)) {
    return fieldCatalog.map((f) => ({ kind: "catalog", key: f.key, token: CT(f.key), enabled: true, label: f.label, input: f.input, options: f.options }));
  }
  return orderedTokens(cfg, fieldCatalog)
    .map((t) => resolveToken(t, cfg, fieldCatalog))
    .filter((d) => d && d.enabled);
}
